import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api, getToken } from "@/lib/api";

const CHATBASE_SCRIPT_ID = "WBi1ImEBHuAmMuPSnxTw7";

export default function ChatbaseWidget() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (document.getElementById(CHATBASE_SCRIPT_ID)) return;

    if (!window.chatbase || window.chatbase("getState") !== "initialized") {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) {
          window.chatbase.q = [];
        }
        window.chatbase.q.push(args);
      };
      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === "q") {
            return target.q;
          }
          return (...args) => target(prop, ...args);
        },
      });
    }

    const onLoad = () => {
      if (document.getElementById(CHATBASE_SCRIPT_ID)) return;
      const script = document.createElement("script");
      script.src = "https://www.chatbase.co/embed.min.js";
      script.id = CHATBASE_SCRIPT_ID;
      script.domain = "www.chatbase.co";
      document.body.appendChild(script);
    };

    if (document.readyState === "complete") {
      onLoad();
    } else {
      window.addEventListener("load", onLoad);
      return () => window.removeEventListener("load", onLoad);
    }
  }, []);

  // Visibilidad: oculto en rutas admin hasta validar la sesión real
  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith("/admin");
    if (!isAdminRoute) {
      setVisible(true);
      return;
    }
    setVisible(false);
    const token = getToken();
    if (!token) return;
    let alive = true;
    api.get("/auth/me")
      .then(() => { if (alive) setVisible(true); })
      .catch(() => { if (alive) setVisible(false); });
    return () => { alive = false; };
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("rocky-hidden", !visible);
  }, [visible]);

  return null;
}
